import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import GlobalLoader from "@/components/common/BrandLogo";
import { RouteAccess } from "@/enum/common.enum";
import { PUBLIC_ROUTES, PROTECTED_ROUTES } from "@/routes/url";

interface ProtectedRouteProps {
  children: ReactNode;
  allow?: RouteAccess;
}

const ProtectedRoute = ({ children, allow = RouteAccess.ANY }: ProtectedRouteProps) => {
  const { user, context, loading } = useAuth() 
  const hasMembership = context && context.membership;
  const requiresInternal = allow === RouteAccess.INTERNAL;
  const requiresExternal = allow === RouteAccess.EXTERNAL;
  if (loading) return <GlobalLoader />;
  if (!user) return <Navigate to={PUBLIC_ROUTES.LOGIN} replace />;
  if (requiresInternal && context && !hasMembership) {
    return <Navigate to={PUBLIC_ROUTES.OVERVIEW} replace />;
  }
  if (requiresExternal && hasMembership) {
    return <Navigate to={PROTECTED_ROUTES.DASHBOARD} replace />;
  }
  return <>{children}</>;
};

export default ProtectedRoute;
